module.exports = __webpack_public_path__ + "packs/media/images/Home_2-0d42041c984c4302a108f3ff290f0d33.jpg";